import { BASE_URL } from "../../config";
import { SET_ERROR_STATE, RESET_STATUS_STATE, REQUEST_STATE, SET_SUCCESS_STATE } from "../../utils/constants/actionTypes";
import { patch_profile_pic, patch_profile_perusahaan, patch_bankaccount_borrower, post_submit_profile, patch_borrower } from "../../config/api";
import bugsnagClient from "../../config/bugsnag";
import Profil from "./Profil";

export const LP_PIC =
	({ ClientID, data }, cb) =>
	async (dispatch) => {
		dispatch({ type: "REQUEST_LP" });
		//console.log("ini mau masuk submit === ", data);

		try {
			let res = await fetch(`${BASE_URL}${patch_profile_pic}`, {
				method: "PATCH",
				credentials: "include",
				headers: {
					"X-Client-ID": ClientID,
					"Content-Type": "application/json",
				},
				body: JSON.stringify({ borrower: { picDetail: data } }),
			});
			let hasil = await res.json();
			if (res.status === 200) {
				dispatch(Profil(ClientID));
				cb(true);
				dispatch({ type: "REQUEST_LP_DONE" });
			} else {
				cb(false);
				dispatch({ type: "REQUEST_LP_DONE" });
				dispatch({ type: SET_ERROR_STATE, payload: hasil.status.message });
				bugsnagClient.notify(new Error(`LengkapiProfile.js/ (line 30) ==> ${res.status} (${hasil.status.code}) - ${hasil.status.message}`));
			}
			console.log("lengkapi profile === ", { res, hasil });
		} catch (err) {
			dispatch({ type: "REQUEST_LP_DONE" });
			cb(false);
			dispatch({ type: SET_ERROR_STATE, payload: err.message });
			bugsnagClient.notify(new Error(`LengkapiProfile.js/ (line 38) ===> catch - ${err.message}`));
		}
	};

export const LP_Company =
	({ ClientID, tokenCIF, data }, cb) =>
	async (dispatch) => {
		dispatch({ type: "REQUEST_LP" });
		//console.log("ini mau masuk submit === ", data);

		try {
			let res = await fetch(`${BASE_URL}${patch_profile_perusahaan}`, {
				method: "PATCH",
				credentials: "include",
				headers: {
					// 'X-Client-ID' : ClientID,
					Authorization: "Bearer " + tokenCIF,
					"Content-Type": "application/json",
				},
				body: JSON.stringify({ customerInformation: data }),
			});
			let hasil = await res.json();
			if (res.status === 200) {
				dispatch(Profil(ClientID));
				cb(true);
				dispatch({ type: "REQUEST_LP_DONE" });
			} else {
				cb(false);
				dispatch({ type: "REQUEST_LP_DONE" });
				dispatch({ type: SET_ERROR_STATE, payload: hasil.status.message });
				bugsnagClient.notify(new Error(`LengkapiProfile.js/ (line 66) ==> ${res.status} (${hasil.status.code}) - ${hasil.status.message}`));
			}
			console.log("lengkapi profile perusahaan === ", { res, hasil });
		} catch (err) {
			dispatch({ type: "REQUEST_LP_DONE" });
			cb(false);
			dispatch({ type: SET_ERROR_STATE, payload: err.message });
			bugsnagClient.notify(new Error(`LengkapiProfile.js/ (line 74) ===> catch - ${err.message}`));
		}
	};

export const LP_BankInfo =
	({ ClientID, data }, cb) =>
	async (dispatch) => {
		dispatch({ type: "REQUEST_LP" });
		//console.log("ini mau masuk submit === ", data);

		try {
			let res = await fetch(`${BASE_URL}${patch_bankaccount_borrower}`, {
				method: "PATCH",
				credentials: "include",
				headers: {
					"X-Client-ID": ClientID,
					"Content-Type": "application/json",
				},
				body: JSON.stringify({ borrower: { bankAccountInfo: data } }),
			});
			let hasil = await res.json();
			console.log("hasil bank inf === ", { res, hasil });

			if (res.status === 200) {
				dispatch(Profil(ClientID));
				cb(true);
				dispatch({ type: "REQUEST_LP_DONE" });
			} else {
				cb(false);
				dispatch({ type: "REQUEST_LP_DONE" });
				dispatch({ type: SET_ERROR_STATE, payload: hasil.status.message });
				bugsnagClient.notify(new Error(`LengkapiProfile.js/ (line 101) ==> ${res.status} (${hasil.status.code}) - ${hasil.status.message}`));
			}
			console.log("lengkapi profile === ", { res, hasil });
		} catch (err) {
			dispatch({ type: "REQUEST_LP_DONE" });
			cb(false);
			dispatch({ type: SET_ERROR_STATE, payload: err.message });
			bugsnagClient.notify(new Error(`LengkapiProfile.js/ (line 109) ===> catch - ${err.message}`));
		}
	};

export const LP_Submit =
	({ ClientID, tokenCIF, data }, cb) =>
	async (dispatch) => {
		dispatch({ type: "REQUEST_LP" });
		//console.log("ini mau masuk submit === ", data);
		try {
			let res = await fetch(`${BASE_URL}${post_submit_profile}`, {
				method: "POST",
				credentials: "include",
				headers: {
					// 'X-Client-ID' : ClientID,
					Authorization: "Bearer " + tokenCIF,
					"Content-Type": "application/json",
				},
				body: JSON.stringify({ customerInformation: data }),
			});
			let hasil = await res.json();
			if (res.status === 200) {
				dispatch(Profil(ClientID));
				cb(true);
				dispatch({ type: "REQUEST_LP_DONE" });
			} else {
				cb(false);
				dispatch({ type: "REQUEST_LP_DONE" });
				dispatch({ type: SET_ERROR_STATE, payload: hasil.status.message });
				bugsnagClient.notify(new Error(`LengkapiProfile.js/ (line 137) ==> ${res.status} (${hasil.status.code}) - ${hasil.status.message}`));
			}
			console.log("lengkapi profile === ", { res, hasil });
		} catch (err) {
			dispatch({ type: "REQUEST_LP_DONE" });
			cb(false);
			dispatch({ type: SET_ERROR_STATE, payload: err.message });
			bugsnagClient.notify(new Error(`LengkapiProfile.js/ (line 145) ===> catch - ${err.message}`));
		}
	};

export const LP_Borrower =
	({ ClientID, data }, cb) =>
	async (dispatch) => {
		dispatch({ type: "REQUEST_LP" });
		//console.log("ini mau masuk submit === ", data);

		try {
			let res = await fetch(`${BASE_URL}${patch_borrower}`, {
				method: "PATCH",
				credentials: "include",
				headers: {
					"X-Client-ID": ClientID,
					"Content-Type": "application/json",
				},
				body: JSON.stringify({ borrower: data }),
			});
			let hasil = await res.json();
			console.log("hasil borr inf === ", { res, hasil });

			if (res.status === 200) {
				cb(true);
				dispatch({ type: "REQUEST_LP_DONE" });
			} else {
				cb(false);
				dispatch({ type: "REQUEST_LP_DONE" });
				dispatch({ type: SET_ERROR_STATE, payload: hasil.status.message });
				bugsnagClient.notify(new Error(`LengkapiProfile.js/ (line 174) ==> ${res.status} (${hasil.status.code}) - ${hasil.status.message}`));
			}
			console.log("lengkapi profile borr === ", { res, hasil });
		} catch (err) {
			dispatch({ type: "REQUEST_LP_DONE" });
			cb(false);
			dispatch({ type: SET_ERROR_STATE, payload: err.message });
			bugsnagClient.notify(new Error(`LengkapiProfile.js/ (line 182) ===> catch - ${err.message}`));
		}
	};
